// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"238":"7d91267d","449":"40047b0d","590":"643a5f3e","617":"49a03919","781":"2f46c130","891":"098af770"}[chunkId] + ".js";
};